//SAVE THIS FILE.. IT IS THE ERROR.JS RENAMED TO ERRORREDUCERNEW.JS
import { SET_ERROR, CLEAR_ERROR } from "../actions/findError";

const initialState = {
  isActive: false,
  code: null,
  description: null,
  message: null,
  status: null,
};

const errorReducer = (state = initialState, action) => {
  if (state === undefined) {
    state = { ...initialState };
  }
  //console.log('in error reducer called with state:', state, 'and action:', action);  // <-- add this line here
  switch (action.type) {
    case SET_ERROR:
      // Handle both direct properties (code, description, message) and payload
      const { code, description, message, status } = action.payload
        ? {
            ...action.payload,
            code: action.payload.code || null,
            status: action.payload.status || null,
          }
        : {
            code: action.code || null,
            description: action.description || null,
            message: action.message || null,
            status: action.status || null,
          };
      return {
        ...state,
        isActive: true,
        code,
        description,
        message,
        status,
      };
    case CLEAR_ERROR:
      return initialState;
    default:
      return state;
  }
};

export default errorReducer;
